import { useState } from 'react';
import { configureFirebase } from 'util/firebase';
import { QueryParamsProvider } from 'contexts/QueryParamsContext';
import { Header } from 'components';
import { Sidebar } from 'components';
import { ViewPort } from 'components';

export const App = () => {
  const [view, setView] = useState('menu');
  const [showSidebar, setShowSidebar] = useState(false);

  configureFirebase();

  return (
    <QueryParamsProvider>
      <Header
        view={view}
        showSidebar={showSidebar}
        setShowSidebar={setShowSidebar}
      />
      <Sidebar
        view={view}
        returnToSelection={() => setView('menu')}
        showSidebar={showSidebar}
        setShowSidebar={setShowSidebar}
      />
      <ViewPort
        view={view}
        changeView={() => setView('drink')}
        returnToSelection={() => setView('menu')}
      />
    </QueryParamsProvider>
  );
};
